//librerias
import { Component, Input } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-my-modal-course-card",
  templateUrl: "./my-modal-course-card.component.html",
  styleUrls: ["./my-modal-course-card.component.css"],
})
export class MyModalCourseCardComponent {
  @Input() data: any;
  constructor(public activeModal: NgbActiveModal) {
    console.log("Data");
    console.log(this.data);
  }
}
